/* ONYX theme behaviour. No libraries. Everything is wired by event delegation, so parts the cart
   or search swap in keep working. Sections: drawers, header (mega menu, dropdowns, search), cart,
   product (options, gallery, sticky bar, video), collection, Shop all page, recommendations. */
(function () {
  'use strict';
  var O = window.Onyx || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var visible = function (el) { return !!(el && el.offsetParent !== null); };
  var closeSearch = function () {};
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- money ---------- */
  function money(cents, trim) {
    var fmt = O.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function withDelims(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
      switch (kind) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
    return trim ? out.replace(/\.00(?!\d)/, '') : out;
  }

  /* ---------- drawers: the mobile menu, the cart, the filters ---------- */
  var openDrawer = null, lastFocus = null;
  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer, true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.classList.add('no-scroll');
    openDrawer = drawer;
    $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $$(FOCUSABLE, drawer).filter(visible);
    setTimeout(function () { (f[1] || f[0] || drawer).focus(); }, 60);
  }
  function close(drawer, keepFocus) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (openDrawer === drawer) openDrawer = null;
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-drawer]').forEach(function (d) { d.setAttribute('aria-hidden', 'true'); });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); close(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { close(openDrawer); return; }
    if (e.key !== 'Tab') return;
    var f = $$(FOCUSABLE, openDrawer).filter(visible);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- the shop browser (menu and Shop all page): switching category ---------- */
  function browserActivate(root, i) {
    if (root.getAttribute('data-current') === i) return false;
    root.setAttribute('data-current', i);
    var main = $('.sb__main', root);
    if (main) main.scrollTop = 0;
    $$('.sb__cat, .sb__grid, .sb__hero', root).forEach(function (el) {
      el.classList.toggle('on', el.getAttribute('data-i') === i);
    });
    $$('.sb__cat', root).forEach(function (el) {
      if (el.getAttribute('data-i') === i) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
    });
    return true;
  }

  /* ---------- header ---------- */
  var header = $('[data-header]');
  if (header) {
    var mega = $('[data-mega]', header);
    var megaItem = $('[data-mega-item]', header);
    var megaLink = $('[data-mega-toggle]', header);

    if (mega && megaItem && megaLink) {
      var sb = $('[data-sb]', mega);
      if (sb) {
        sb.setAttribute('data-current', '1');
        $$('.sb__cat', sb).forEach(function (el) {
          var go = function () { browserActivate(sb, el.getAttribute('data-i')); };
          el.addEventListener('mouseenter', go); el.addEventListener('focus', go); el.addEventListener('click', go);
        });
      }
      var t;
      var isOpen = function () { return mega.classList.contains('is-open'); };
      var place = function () { mega.style.maxHeight = Math.max(240, window.innerHeight - header.getBoundingClientRect().bottom) + 'px'; };
      var openMega = function () {
        clearTimeout(t); closeSearch(); place();
        mega.removeAttribute('inert'); mega.classList.add('is-open');
        megaItem.classList.add('is-open'); megaLink.setAttribute('aria-expanded', 'true');
      };
      var closeMegaNow = function () {
        clearTimeout(t); mega.classList.remove('is-open'); mega.setAttribute('inert', '');
        megaItem.classList.remove('is-open'); megaLink.setAttribute('aria-expanded', 'false');
      };
      var closeMega = function () { clearTimeout(t); t = setTimeout(closeMegaNow, 160); };
      var megaFocusables = function () { return $$('a[href], button', mega).filter(visible); };
      megaItem.addEventListener('mouseenter', openMega);
      megaItem.addEventListener('mouseleave', closeMega);
      mega.addEventListener('mouseenter', function () { clearTimeout(t); });
      mega.addEventListener('mouseleave', closeMega);
      /* touch: the first tap opens, a second follows the link */
      var lastPointer = '', wasOpen = false;
      megaLink.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType; wasOpen = isOpen(); });
      megaLink.addEventListener('click', function (e) {
        if ((lastPointer === 'touch' || lastPointer === 'pen') && !wasOpen) { e.preventDefault(); openMega(); }
        lastPointer = '';
      });
      /* keyboard: Down arrow or Space opens it and moves in; Enter follows the link */
      megaLink.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); openMega();
          var f = megaFocusables(); if (f.length) f[0].focus();
        } else if (e.key === 'Escape' && isOpen()) { closeMegaNow(); }
      });
      mega.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeMegaNow(); megaLink.focus(); return; }
        if (e.key !== 'Tab') return;
        var f = megaFocusables(); if (!f.length) return;
        if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
          e.preventDefault(); closeMegaNow();
          var all = $$(FOCUSABLE, header).filter(visible);
          var after = all.slice(all.indexOf(megaLink) + 1).filter(function (el) { return !mega.contains(el); });
          (after[0] || megaLink).focus();
        } else if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); megaLink.focus(); }
      });
      mega.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to && !mega.contains(to) && to !== megaLink) closeMegaNow();
      });
      document.addEventListener('click', function (e) {
        if (isOpen() && !mega.contains(e.target) && !megaItem.contains(e.target)) closeMegaNow();
      });
      window.addEventListener('resize', function () { if (isOpen()) place(); });
    }

    /* small dropdowns (Help) */
    $$('[data-drop-item]', header).forEach(function (item) {
      var link = $('[data-drop-toggle]', item), drop = $('[data-drop]', item), t2, shut = false;
      var show = function () { clearTimeout(t2); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
      var hideNow = function () { clearTimeout(t2); item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); };
      var hide = function () { clearTimeout(t2); t2 = setTimeout(hideNow, 160); };
      item.addEventListener('mouseenter', function () { shut = false; show(); });
      item.addEventListener('mouseleave', hide);
      link.addEventListener('focus', function () { if (!shut) show(); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { hideNow(); shut = false; } });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); shut = true; hideNow(); link.focus(); }
        if (e.key === 'ArrowDown' && document.activeElement === link) { e.preventDefault(); show(); var a = $('a', drop); if (a) a.focus(); }
      });
      var lp = '', was = false;
      link.addEventListener('pointerdown', function (e) { lp = e.pointerType; was = item.classList.contains('is-open'); });
      link.addEventListener('click', function (e) { if ((lp === 'touch' || lp === 'pen') && !was) { e.preventDefault(); show(); } lp = ''; });
      document.addEventListener('click', function (e) { if (!item.contains(e.target)) hideNow(); });
    });

    /* search */
    var searchBtn = $('[data-search-toggle]', header), panel = $('[data-search-panel]', header);
    var input = panel && $('[data-predict-input]', panel), results = panel && $('[data-predict-results]', panel);
    closeSearch = function () {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); panel.setAttribute('inert', ''); searchBtn.setAttribute('aria-expanded', 'false');
    };
    if (searchBtn && panel) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) { closeSearch(); return; }
        if (mega) { mega.classList.remove('is-open'); mega.setAttribute('inert', ''); if (megaItem) megaItem.classList.remove('is-open'); if (megaLink) megaLink.setAttribute('aria-expanded', 'false'); }
        panel.classList.add('is-open'); panel.removeAttribute('inert'); searchBtn.setAttribute('aria-expanded', 'true');
        setTimeout(function () { input.focus(); }, 30);
      });
      panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); searchBtn.focus(); } });
      document.addEventListener('click', function (e) {
        if (panel.classList.contains('is-open') && !panel.contains(e.target) && !searchBtn.contains(e.target)) closeSearch();
      });
      var timer, lastQ = '', ctrl;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () {
          if (q === lastQ) return;
          lastQ = q;
          if (q.length < 2) { results.innerHTML = ''; return; }
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var url = (O.routes.predictive || '/search/suggest') + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
          fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.shopify-section') || doc.body;
            results.innerHTML = sec.innerHTML;
          }).catch(function () {});
        }, 220);
      });
    }
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var box = step.closest('[data-qty]'), inp = box && $('input', box);
    if (!inp) return;
    var min = inp.hasAttribute('min') ? Number(inp.min) : 0;
    inp.value = Math.max(min, (Number(inp.value) || 0) + Number(step.getAttribute('data-qty-step')));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */
  var drawer = document.getElementById('CartDrawer');
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('aria-label', n + ' items'); });
  }
  function swapDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]'), cur = $('[data-cart-inner]', drawer);
    if (fresh && cur) { cur.replaceWith(fresh); setCount(Number(fresh.getAttribute('data-count')) || 0); }
  }
  function sectionId(el) {
    var s = el && el.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  document.addEventListener('click', function (e) {
    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && drawer && !document.querySelector('[data-cart-page]')) { e.preventDefault(); open(drawer); }
  });
  function changeLine(line, qty, scope) {
    var page = scope.closest('[data-cart-page]');
    var ids = ['cart-drawer'];
    var pageId = page ? sectionId(page) : null;
    if (pageId) ids.push(pageId);
    scope.classList.add('is-busy');
    return fetch((O.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ids.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) {
        var err = $('[data-cart-error]', scope.closest('[data-cart-inner], [data-cart-page]') || document);
        if (err) { err.textContent = res.j.description || res.j.message || 'That didn\'t go through. Try again.'; err.hidden = false; }
        return;
      }
      var sections = res.j.sections || {};
      swapDrawer(sections['cart-drawer']);
      if (pageId && sections[pageId]) {
        var doc = new DOMParser().parseFromString(sections[pageId], 'text/html');
        var fresh = doc.querySelector('[data-cart-page]');
        if (fresh) page.replaceWith(fresh);
      }
      setCount(res.j.item_count);
    }).catch(function () { window.location.reload(); }).finally(function () { scope.classList.remove('is-busy'); });
  }
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-line-qty]');
    if (!inp) return;
    changeLine(Number(inp.getAttribute('data-line-qty')), Math.max(0, Number(inp.value) || 0), inp.closest('.line') || inp);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(Number(rm.getAttribute('data-line-remove')), 0, rm.closest('.line') || rm);
  });

  /* add to cart: any product form (the buy box, the comparison table) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !drawer || !window.fetch) return;
    e.preventDefault();
    var btns = $$('[name="add"], [type="submit"]', form).concat(form.id ? $$('[form="' + form.id + '"][name="add"]') : []);
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch((O.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = res.j.description || res.j.message || 'That didn\'t go into the cart. Try again.'; err.hidden = false; }
          return;
        }
        swapDrawer(res.j.sections && res.j.sections['cart-drawer']);
        open(drawer);
      })
      .catch(function () { form.submit(); })
      .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); }); });
  });

  /* ---------- product ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = root.parentNode.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    // each variant's price as Shopify formats it, in the visitor's currency
    var labelsEl = root.parentNode.querySelector('[data-price-labels]');
    var labels = labelsEl ? JSON.parse(labelsEl.textContent) : {};
    var form = $('[data-product-form]', root);
    var sticky = root.parentNode.querySelector('[data-sticky-buy]');

    /* gallery */
    var gallery = $('[data-gallery]', root);
    var slides = gallery ? $$('.gallery__slide', gallery) : [];
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('on'); }));
    function show(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      $$('[data-thumb]', gallery).forEach(function (t) {
        var on = Number(t.getAttribute('data-thumb')) === i;
        t.classList.toggle('on', on);
        if (on && t.parentNode.scrollTo) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      var count = $('[data-gallery-count]', gallery);
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      $$('video', gallery).forEach(function (v) {
        if (!v.closest('.on')) v.pause();
        else { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var th = e.target.closest('[data-thumb]');
        if (th) { show(Number(th.getAttribute('data-thumb'))); return; }
        var st = e.target.closest('[data-gallery-step]');
        if (st) show(current + Number(st.getAttribute('data-gallery-step')));
      });
      var main = $('.gallery__main', gallery), x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    /* options */
    if (product && form) {
      var idInput = $('[data-variant-id]', form);
      var priceEl = $('[data-price]', root), perEl = $('[data-per]', root), stockEl = $('[data-stock]', root);
      var stickyPrice = sticky && $('[data-sticky-price]', sticky);
      var addBtns = $$('[data-add]', root).concat(sticky ? $$('[data-add]', sticky) : []);
      var selected = function () {
        var vals = [];
        for (var p = 1; p <= product.options.length; p++) {
          var c = $('input[name="option' + p + '"]:checked', form);
          vals.push(c ? c.value : null);
        }
        return vals;
      };
      var findVariant = function (vals) {
        return product.variants.find(function (v) { return v.options.every(function (o, k) { return o === vals[k]; }); });
      };
      var markUnavailable = function (vals) {
        if (product.options.length < 2) return;
        $$('input[name^="option"]', form).forEach(function (inp) {
          var pos = Number(inp.getAttribute('data-option')) - 1;
          var test = vals.slice(); test[pos] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      };
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[name^="option"]')) return;
        var vals = selected(), v = findVariant(vals);
        markUnavailable(vals);
        addBtns.forEach(function (b) {
          b.disabled = !v || !v.available;
          b.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
        });
        if (!v) { if (stockEl) stockEl.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        var price = labels[v.id] || money(v.price, true);
        if (priceEl) priceEl.textContent = price;
        if (stickyPrice) stickyPrice.textContent = price;
        if (perEl) perEl.textContent = e.target.getAttribute('data-per') || '';
        if (stockEl) { stockEl.textContent = v.available ? 'In stock' : 'Sold out'; stockEl.classList.toggle('stock--out', !v.available); }
        if (v.featured_media && gallery) {
          var slide = $('[data-media-id="' + v.featured_media.id + '"]', gallery);
          if (slide) show(Number(slide.getAttribute('data-slide')));
        }
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      });
      markUnavailable(selected());
    }

    /* the bar along the bottom appears once the buy buttons scroll away */
    var buy = $('[data-buy-buttons]', root);
    if (sticky && buy) {
      var frame = 0;
      var check = function () {
        frame = 0;
        var gone = buy.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('show', gone);
        sticky.setAttribute('aria-hidden', gone ? 'false' : 'true');
        $$('button, a', sticky).forEach(function (b) { b.tabIndex = gone ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(check); }, { passive: true });
      check();
    }
  });

  /* ---------- clips: muted video in the hero and image bands ----------
     The source goes in only when a clip is due: once the page has loaded and the clip is on screen,
     one at a time, the phone-sized copy on phones. Several clips take turns. Nothing loads for
     anyone who has asked for less motion or to save data; the photo stays. */
  (function () {
    var boxes = $$('[data-clips]');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    if (!boxes.length || calm || save) return;
    var phone = window.matchMedia('(max-width: 749px)').matches;
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function begin() {
      boxes.forEach(function (box) {
        var vids = $$('video[data-src]', box);
        if (!vids.length) return;
        var secs = Math.max(3, Number(box.getAttribute('data-rotate')) || 7);
        var i = -1, timer = null, inView = false, started = false;
        function load(v) {
          if (v.getAttribute('src')) return;
          v.addEventListener('error', function () { v.bad = true; if (vids[i] === v) next(); }, { once: true });
          v.src = (phone && v.getAttribute('data-src-sm')) || v.getAttribute('data-src');
          v.load();
        }
        function show(n) {
          var v = vids[n];
          i = n;
          load(v);
          var go = function () {
            if (vids[i] !== v) return;
            try { v.currentTime = 0; } catch (e) {}
            if (inView && !document.hidden) play(v);
            vids.forEach(function (o) { o.classList.toggle('on', o === v); });
            setTimeout(function () { vids.forEach(function (o) { if (o !== vids[i]) o.pause(); }); }, 1000);
            if (vids.length > 1) {
              clearTimeout(timer);
              timer = setTimeout(next, secs * 1000);
              setTimeout(function () { var nx = vids[(n + 1) % vids.length]; if (!nx.bad) load(nx); }, Math.max(0, secs - 3) * 1000);
            }
          };
          if (v.readyState >= 3) go(); else v.addEventListener('canplay', go, { once: true });
        }
        function next() {
          clearTimeout(timer);
          if (!inView || document.hidden) { timer = setTimeout(next, 1000); return; }
          var n = i;
          for (var k = 0; k < vids.length; k++) { n = (n + 1) % vids.length; if (!vids[n].bad) { show(n); return; } }
        }
        function watch(on) {
          inView = on;
          var v = vids[i];
          if (on && !started) { started = true; show(0); }
          else if (v && v.classList.contains('on')) { if (on) play(v); else v.pause(); }
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { watch(es[es.length - 1].isIntersecting); }, { rootMargin: '150px 0px' }).observe(box);
        } else watch(true);
        document.addEventListener('visibilitychange', function () {
          var v = vids[i];
          if (!v || !v.classList.contains('on')) return;
          if (document.hidden) v.pause(); else if (inView) play(v);
        });
      });
    }
    if (document.readyState === 'complete') begin(); else window.addEventListener('load', begin);
  })();

  /* driving footage: the video loads when someone presses play */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.video__play');
    if (!btn) return;
    var box = btn.closest('[data-video]'), id = box.getAttribute('data-video');
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    f.title = btn.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    box.appendChild(f); btn.remove();
  });

  /* ---------- collections: sorting submits by itself ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- the Shop all page ---------- */
  var shopAll = $('[data-shop-all]');
  if (shopAll) {
    var sbp = $('[data-sb]', shopAll), nav = $('.sb__nav', shopAll), items = $$('.sb__cat', shopAll);
    var catOf = function (i) { var g = $('.sb__grid[data-i="' + i + '"]', shopAll); return g ? g.getAttribute('data-cat') : ''; };
    var barHeight = function () {
      var h = $('.hdr-section') || header;
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return r.top <= 0 ? r.bottom : 0;
    };
    var setTop = function () { shopAll.style.setProperty('--sa-top', Math.max(0, Math.round(barHeight())) + 'px'); };
    var keepInView = function (el) { if (nav && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = el.offsetLeft - nav.offsetLeft - (nav.clientWidth - el.offsetWidth) / 2; };
    var showProducts = function () { var top = shopAll.getBoundingClientRect().top, bar = barHeight(); if (top < bar) window.scrollTo(0, window.pageYOffset + top - bar); };
    var choose = function (el, remember) {
      var i = el.getAttribute('data-i');
      if (browserActivate(sbp, i)) {
        if (remember && history.replaceState) { try { history.replaceState(history.state, '', '#' + catOf(i)); } catch (err) {} }
        showProducts();
      }
    };
    items.forEach(function (el) {
      el.addEventListener('focus', function () { choose(el, true); });
      el.addEventListener('click', function () { choose(el, true); keepInView(el); });
    });
    var fr = 0;
    var later = function () { if (!fr) fr = requestAnimationFrame(function () { fr = 0; setTop(); }); };
    window.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    setTop();
    sbp.setAttribute('data-current', '');
    var want = (location.hash || '').slice(1), start = items[0];
    items.forEach(function (el) { if (want && catOf(el.getAttribute('data-i')) === want) start = el; });
    if (start) { browserActivate(sbp, start.getAttribute('data-i')); keepInView(start); }
  }

  /* ---------- related products, under anything that isn't a driving light ---------- */
  $$('[data-recs]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url || box.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();
